import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export type TVerticalPosition = 'left' | 'right';
export type THorizontalPosition = 'top' | 'bottom';

export type TVerticalProps = {
    $position: TVerticalPosition,
}

export type THorizontalProps = {
    $position: THorizontalPosition,
}

const Strip = styled.div`
    display: block;
    position: absolute;
    cursor: pointer;

    background: ${COLORS.Outline_Light};
    border-radius: 12px;
`;

const VerticalStrip = styled(Strip)<TVerticalProps>`
    top: calc(50% - 20px);

    height: 40px;
    width: 4px;
    ${({ $position }) => `${$position === 'left' ? 'right' : 'left'}: 10px`};
`;

const HorizontalStrip = styled(Strip)<THorizontalProps>`
    left: calc(50% - 20px);

    width: 40px;
    height: 4px;
    ${({ $position }) => `${$position === 'top' ? 'bottom' : 'top'}: 10px`};
`;

export {
    HorizontalStrip,
    VerticalStrip,
};
